import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type CompanyLogo as SchemaCompanyLogo } from '../schemas/CompanyLogo';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const GetCompanyLogoContentType = '' as const;
export type GetCompanyLogoRequest = void;
export type GetCompanyLogoResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful get company logo
     */
    '200': {
        'application/json': SchemaCompanyLogo;
    };
};
export type GetCompanyLogoResponseSuccess = GetCompanyLogoResponses['200']['application/json'];
export type GetCompanyLogoSearchParams = undefined;
export type GetCompanyLogoPathParameters = undefined;
export const GetCompanyLogoUrl = '/company/logo' as const;
export const GetCompanyLogoMethod = 'GET' as const;
export const getGetCompanyLogoUrl = (_params?: GetCompanyLogoPathParameters) => GetCompanyLogoUrl;
